let host = '';

if (process.env.NODE_ENV === 'development') {
  host = 'http://exmark.int.devsmm.com';
}

export default {
  rootRoute: '/home',
  labelEndpoint: `${host}/simulator/labels`
};



// WEBPACK FOOTER //
// ./src/constants/constants.js